
import { defineComponent, reactive, toRefs, watchEffect, watch } from 'vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import { CaretDownOutlined } from '@ant-design/icons-vue'
export default defineComponent({
  components: { CaretDownOutlined },
  props: {
    theme: {
      type: String,
      default: () => {
        return 'light'
      }
    },
    reportDatas: {
      type: Array,
      default: () => {
        return []
      }
    },
    defaultReportDate: {
      type: Number,
      default: () => {
        return 0
      }
    }
  },
  setup(props: any, context) {
    const pageData: any = reactive({
      grade: 0,
      reportDate: '',
      reportDates: [],
      getPopupContainer: (e: any) => e.parentNode,
      theme: props.theme
    })
    watch(
      () => props.reportDatas,
      (val: any) => {
        pageData.reportDates = (val || []).map((item: any) => {
          return {
            value: item,
            label: item && window.moment(item * 1000).format('YYYY-MM-DD')
          }
        })
        if (props.defaultReportDate) {
          pageData.reportDate = props.defaultReportDate
        }
      }
    )
    watch(
      () => props.defaultReportDate,
      (val: any) => {
        pageData.reportDate = props.defaultReportDate
      }
    )
    const route = useRoute()
    function changeReportDate(value: any) {
      pageData.reportDate = value
      context.emit('changeReportDate', pageData.reportDate)
    }
    function changeGrade(value: any) {
      pageData.grade = value
      context.emit('changeGrade', pageData.grade)
    }
    // watch(pageData.grade, () => {
    //   context.emit('changeGrade', pageData.grade)
    // })
    return {
      ...toRefs(pageData),
      changeReportDate,
      changeGrade,
      route
    }
  }
})
